/* eslint-disable @typescript-eslint/no-explicit-any */
import { call } from "redux-saga/effects";

import { UserMetadata } from "../../types/auth";
import { supabase } from "@/lib/supabase";
import { BRANDS_TABLE_NAME } from "../const";

import { throwOnSupabaseError } from "../../utils/errors";

import { applySagaError } from "./applySagaError";

export function* createInitBrandsSaga(brands: any) {
  try {
    const { error } = yield call(() =>
      supabase
        .from(BRANDS_TABLE_NAME)
        .insert(brands)
    );

    throwOnSupabaseError(error);
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "utils.createInitBrands",
      notifyUser: false,
    });
  }
}

export function* updateUserDataSaga(data: UserMetadata) {
  try {
    const { data: { user }, error } = yield call(() =>
      supabase.auth.updateUser({ data })
    );

    throwOnSupabaseError(error);

    return user;
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "auth.updateUserMetadata",
      notifyUser: false,
    });
  }
}
